export const IS_LEGACY_USER_PENDING_ACTIVATION = "isLegacyUserPendingActivation";
export const FIRST_TIME_SALESFORCE_ACTIVITY = "firstTimeSalesforceActivity";
export const USER_COMPLETED_ACTIVATION = "userCompletedActivation";
export const USER_CLOSED_AGENT_ACTIVATION = "userClosedAgentActivation";
